import '../styles/Links.scss';
import {useState, useEffect, ChangeEvent} from 'react';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLink, faSearch } from '@fortawesome/free-solid-svg-icons';
import UniInput, { FormControlElement } from '../components/UniInput/UniInput';
import { Link, getUsefulLinks,getCountries, Country } from '../services/usefulLinkService';
import UniModalLinkNew from '../components/UniModalLinkNew/UniModalLinkNew';
import Skeleton from 'react-loading-skeleton';
import UniPagination from '../components/UniPagination/UniPagination';
import UniModalLinkEdit from '../components/UniModalLinkEdit/UniModalLinkEdit';

type SearchForm = {
    search?: string,
    isActive?: string,
    country?: string
};

const Links = () => {
    const { i18n, t } = useTranslation();
    const [reload, setReload] = useState(false);
    const [showNewLinkModal, setShowNewLinkModal] = useState(false);
    const [showEditLinkModal, setShowEditLinkModal] = useState(false);
    const [usefulLinks, setUsefulLinks] = useState<Link[] | undefined>();
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string>();
    const [countries, setCountries] = useState<Country[] | undefined>();
    const [take, setTake] = useState<number>(10);
    const [page, setPage] = useState<number>(1);
    const [totalPages, setTotalPages] = useState<number>();
    const [totalItems, setTotalItems] = useState<number>();
    const [search, setSearch] = useState<SearchForm>();

    const [linkToEdit, setLinkToEdit] = useState<Link>();

    useEffect(() =>{
        getLinks();
        getGroupsLink();
    }, [take, page]);

    useEffect(() =>{
        if(!showEditLinkModal){
            getLinks();
        }
    }, [ showEditLinkModal]);

    useEffect(() =>{
        if(!showNewLinkModal){
            getLinks();
        }
    }, [  showNewLinkModal]);

    const getLinks = () => {
        setLoading(true)
        getUsefulLinks(take, page, search?.search ?? '', search?.country ?? '',search?.isActive ?? '', i18n.language)
        .then(response => {
            if (!response.success) {
                setError(response.error);
                setUsefulLinks([]);
            }
            else {
                setUsefulLinks(response.links);
                setTotalItems(response.totalItems);
                setTotalPages(response.totalPages);
                setError(response.error);
            }
        })
        .catch(e => console.log(e))
        .finally(() => setLoading(false));
    }

    const onChangeStatus = (e: ChangeEvent<HTMLSelectElement>) => {
        setSearch({ ...search, isActive: e?.target?.value });
    }

    const onChangeCountry = (e: ChangeEvent<HTMLSelectElement>) => {
        setSearch({ ...search, country: e?.target?.value });
        console.log(search?.country)
        console.log(e?.target?.value)
    }

    const onChangeSearch = (e: ChangeEvent<FormControlElement>) => {
        setSearch({ ...search, search: e?.target?.value });
    }

    const getGroupsLink = () =>{
        setLoading(true)
        getCountries()
        .then(response => {
            if (!response.success) {
                setError(response.error);
                console.log(error)
            }
            else {
                setCountries(response.countries);
            }
        })
        .catch(e => console.log(e))
        .finally(() => setLoading(false));

    };

    const getCountryDescription = (country : Country) => {
        switch (i18n.language) {
          case 'es':
            return country.descriptionES;
          case 'en':
            return country.descriptionEN;
          default:
            return country.descriptionBR;
        }
      };


        const mockStatusStyle = [
            {
                // name: UserStatus.Active,
                color: '#30c10c',
                bgColor: '#eefff2',
            },
            {
                // name: UserStatus.Inactive,
                bgColor: '#FFEFEA',
                color: '#FF6636',
            }
        ];

        const mockDataTable = {
            headers: [
                {
                    property: (i18n.language === 'pt' ? 'titleBR':i18n.language === 'es' ? 'titleES': 'titleEN'),
                    name: t('link.labelTitle'),
                    isTitle: true,
                    isCheck: false,
                },
                {
                    property: (i18n.language === 'pt' ? 'descriptionBR':i18n.language === 'es' ? 'descriptionES': 'descriptionEN'),
                    name: t('link.labelDescription'),
                    isDescription: true
                },
                {
                    property: 'link',
                    name: t('link.labelLink'),
                    isLink: true
                },
                {
                    property: (i18n.language === 'pt' ? 'descriptionBR': i18n.language === 'es' ? 'descriptionES': 'descriptionEN'),
                    name: t('link.labelCountry'),
                    isCountry: true,
                },
                {
                    property: 'isActive',
                    name: t('link.labelStatus'),
                    isStatus: true
                },
                {
                    property: 'actions',
                    name: '',
                    isAction: true
                },
            ]
        };

    return(
        <>
            <div className='link-wrapper'>
                <div className='my-link-header w-100'>
                    <div className='my-link-header-i'>
                        <FontAwesomeIcon icon={faLink} color='#00FF3C' size='xl' />
                        <p className='w-100'>{t('links')}</p>
                    </div>

                    <Button variant='primary' onClick={() => setShowNewLinkModal(true)} disabled={loading}>
                        <FontAwesomeIcon style={{ paddingRight: '5px' }} icon={faLink} color='#00FF3C' size='xl' />
                        {t('link.newLink')}
                    </Button>
                </div>

                <div className='my-link-search w-100'>
                    <div>
                        <UniInput
                            id='search'
                            placeholder={t('link.searchFields')}
                            label={t('link.search')}
                            type='text'
                            onChangeInput={(e) => onChangeSearch(e)}
                            disabled={loading}
                        />
                    </div>
                    <div>
                        <UniInput
                            id='status'
                            label='Status'
                            isSelect
                            defaultValue={''}
                            onChange={e => onChangeStatus(e)}
                            disabled={loading}
                        >
                            <option value={''}>{t('link.selectAll')}</option>
                            <option value={'true'}>{t('link.active')}</option>
                            <option value={'false'}>{t('link.inactive')}</option>
                        </UniInput>
                    </div>
                    <div>
                        <UniInput
                            id='country'
                            label={t('link.labelCountry')}
                            isSelect
                            defaultValue={''}
                            onChange={e => onChangeCountry(e)}
                            disabled={loading}
                        >
                            <option value={''}>{t('link.selectAll')}</option>
                             {countries?.map(country => (
                                <option key={country.id} value={country.id}>
                                 { getCountryDescription(country)}
                                </option>
                            ))}
                        </UniInput>
                    </div>
                   <FontAwesomeIcon icon={faSearch} title={t('link.search')} onClick={() => getLinks()} aria-disabled={loading}/>
                </div>

                <div className='w-100 d-flex justify-content-center'>
                    <div className='table-uni'>
                        <table>
                            <tr className='table-header'>
                                {
                                    mockDataTable.headers.map(header => (
                                        <td key={header.name} className={header.isCheck ? `check-header` : ``}>
                                            {
                                                <>
                                                    {header.name}
                                                </>
                                            }
                                        </td>
                                    ))
                                }
                            </tr>
                            {
                                loading ? (
                                        <Skeleton
                                            width={'100%'}
                                            height={400}
                                            duration={1}
                                            highlightColor={ '#f5f5f5'}
                                            baseColor={'#ebebeb'}/>
                                ) :
                                (
                                    error ? (<p className='w-100 text-center p-2'>{t('customerScreen.searchNotFound')}</p>) :
                                    <tbody>
                                        {
                                            usefulLinks?.map((link: any, idx) => (
                                                <tr key={idx.toString()}>
                                                    {
                                                        mockDataTable.headers.map((header, idxh) => {
                                                            if (header.isStatus) {
                                                                return (
                                                                    <td>
                                                                    <div key={header.name} style={{ maxWidth: 60 }}>
                                                                        <div className='table-status' style={{ backgroundColor: link?.[header.property] ? mockStatusStyle[0].bgColor : mockStatusStyle[1].bgColor ?? '#fff', minWidth: 145 }}>
                                                                            <span className='table-status-icon' style={{ backgroundColor: link?.[header.property] ? mockStatusStyle[0].color : mockStatusStyle[1].color ?? '#fff' }}></span>
                                                                            <div className='w-100' style={{ fontSize: 11 }}>{link?.[header.property] ? t('user.active') : t('user.inactive')}</div>
                                                                        </div>
                                                                    </div>
                                                                    </td>
                                                                );
                                                            }

                                                            if (header.isTitle) {
                                                                return (
                                                                    <td key={idxh.toString() + idx.toString()} title={link?.[header.property] ?? '-'}> {link?.[header.property]} </td>
                                                                );
                                                            }

                                                            if (header.isDescription) {
                                                                return (
                                                                    <td key={idxh.toString() + idx.toString()} title={link?.[header.property] ?? '-'}> {link?.[header.property]} </td>
                                                                );
                                                            }

                                                            if (header.isLink) {
                                                                return (
                                                                    <td key={idxh.toString() + idx.toString()} title={link?.[header.property] ?? '-'}> {link?.[header.property]} </td>
                                                                );
                                                            }

                                                            if (header.isCountry) {
                                                                return (
                                                                    <td style={{ paddingLeft: '20px' }} key={idxh.toString() + idx.toString()} title={link?.group?.[header.property] ?? '-'}> {link?.group?.[header.property]} </td>
                                                                );
                                                            }

                                                            if (header.isStatus) {
                                                                return (
                                                                    <td key={idxh.toString() + idx.toString()} title={link?.[header.property] ?? '-'}> {link?.[header.property]} </td>
                                                                );
                                                            }

                                                            if (header.isAction) {

                                                                return (<Button variant='outline' onClick={() => {
                                                                    setShowEditLinkModal(true);
                                                                    setLinkToEdit(link);
                                                                }}>{t('link.editLink')}</Button>);
                                                            }

                                                            return (
                                                                <div key={header.name} title={link?.[header.property]}>{link?.[header.property] ? link?.[header.property]?.length > 10 ? link?.[header.property]?.slice(0, 23) + '...' : link?.[header.property] : '-'}</div>
                                                            )
                                                        })
                                                    }
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                )
                            }
                        </table>
                    </div>
                </div>
                {
                    <UniPagination totalItems={totalItems} totalPages={totalPages} changePage={(e) => setPage(e)} changeTake={(e) => { setPage(1); setTake(e) }} />
                }
            </div>

            <UniModalLinkNew show={showNewLinkModal} onHide={() => {
                setShowNewLinkModal(false);
                setReload(!reload);
            }} />

            <UniModalLinkEdit linkToEdit={linkToEdit} show={showEditLinkModal} onHide={() => {
                setShowEditLinkModal(false);
                setReload(!reload);
            }} />
        </>
    );
}

export default Links;
